import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
} from 'reactstrap';
import CheckBox from '@componentes/checkbox/checkbox.component';
import IntlMessage from "../../../helpers/intlMessage";

function BlocoLote({
	blocosParaEtiqueta,
	showModal,
	toggleModal,
	imprimirEtiquetas,
}) {
	const [blocosMarcados, setBlocosMarcados] = useState([]);
	const [cassete35, setCassete35] = useState(false);
	const [cassete45, setCassete45] = useState(false);
	const [estadoMarcarDesmarcarTodos, setOpcaoMarcarDesmarcarTodos] = useState(true);
	const [labelMarcarDesmarcarTodos, setLabelMarcarDesmarcarTodos] = useState("Desmarcar todos");

	useEffect(() => {
		const blocos = [];
		blocosParaEtiqueta.map((el) => blocos.push(el.id));
		setBlocosMarcados(blocos);
	}, []);

	const checkboxOnChange = (idBloco) => {
		const index = blocosMarcados.findIndex((el) => el === idBloco);
		const blocos = [...blocosMarcados];

		if (index >= 0) {
			blocos.splice(index, 1);
		} else {
			blocos.push(idBloco);
		}

		setBlocosMarcados(blocos);
	};

	const marcarDesmarcarTudo = (marcado) =>
	{
		let blocos = [];
		let label = "Marcar todos";

		if (marcado)
		{
		    blocosParaEtiqueta.map((el) => blocos.push(el.id));
			label = "Desmarcar todos";
		}

		setBlocosMarcados(blocos);
		setOpcaoMarcarDesmarcarTodos(marcado);
		setLabelMarcarDesmarcarTodos(label);
	}

	return (
		<Modal size="lg" isOpen={showModal} toggle={toggleModal}>
			<ModalHeader toggle={toggleModal}><IntlMessage id = "dashboards.cytology.printLabelsBatch"/></ModalHeader>
			<ModalBody>
				<Row style={{maxHeight: '280px', overflowX: 'hidden', overflowY: 'hidden'}}>
					<Col sm="4" key='0'>
						<CheckBox
							label={labelMarcarDesmarcarTodos}
							onChange={() => marcarDesmarcarTudo(!estadoMarcarDesmarcarTodos)}
							checked={estadoMarcarDesmarcarTodos}
						/>
					</Col>
				</Row>
				<Row style={{maxHeight: '280px', overflowX: 'hidden', overflowY: 'scroll'}}>
					{blocosParaEtiqueta.map((el, i) => {
						const css =
							el.data.finalizacao === <IntlMessage id = "dashboards.reports.pending"/>
								? ' checkbox-pendente'
								: el.data.finalizacao === <IntlMessage id = "dashboards.reports.inProgress"/>
									? ' checkbox-executando'
									: ' checkbox-finalizado';
						return (
							<Col sm="4" key={el.id}>
								<CheckBox
									checkmarkClassName={css}
									key={i}
									label={el.data.nrBloco}
									checked={
										blocosMarcados.findIndex(
											(blocoMarcado) => blocoMarcado === el.id
										) >= 0
									}
									onChange={() => checkboxOnChange(el.id)}
								/>
							</Col>
						);
					})}
				</Row>
			</ModalBody>
			<ModalFooter>
				<CheckBox
					label="Cassete 35 graus"
					onChange={
						() => {
							if (cassete45) {
								setCassete45(!cassete45)
							}

							setCassete35(!cassete35)
						}
					}
					checked={cassete35}
				/>
				<CheckBox
					label="Cassete 45 graus"
					onChange={
						() => {
							if (cassete35) {
								setCassete35(!cassete35)
							}

							setCassete45(!cassete45)
						}
					}
					checked={cassete45}
				/>
 				<Button
					onClick={() => imprimirEtiquetas(blocosMarcados, cassete35, cassete45)}
					disabled={blocosParaEtiqueta.length === 0 || blocosMarcados.length === 0}
					color="primary"
				>
					<IntlMessage id = "dashboards.examDetails.confirm"/>
				</Button>
			</ModalFooter>
		</Modal>
	);
}

const mapStateToProps = (state) => ({
	impressoras: state.commonReducer.impressoras,
});

const mapDispacthToProps = (dispatch) => ({
	commonActions: bindActionCreators(commonActions, dispatch),
});

export default connect(mapStateToProps, mapDispacthToProps)(BlocoLote);



// WEBPACK FOOTER //
// ./src/pages/histologia/common/bloco.lote.js